import React from 'react';
import Navbar from '../components/Navbar';
import WindowManager from '../components/WindowManager';
import { useIsDesktop } from '../contexts/useScreenSize';
import AndroidNavbar from '../components/AndroidNavbar'; // Nova Navbar para Android
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function HomePage() {
  const isDesktopLike = useIsDesktop(1024);
  const navigate = useNavigate();
  return (
    <div>
      <>
      <Button
      
      onClick={() =>  navigate(`/home/printPedido/12`) }   
      >


      </Button>
      <WindowManager />
      <Navbar />
      </>
    </div>
  );
}

export default HomePage;